<template>
	<form v-on:submit.prevent="validateBeforeSubmit">
		<ejs-progressbutton 
			type="submit" 
			cssClass="e-primary"
			ref="progressBtn"
			:disabled="disabledButton"
			:spinSettings="spinSettings"
			:duration="50000"
		>
			{{ $t("textBtn.btnSearch") }}
		</ejs-progressbutton>
	</form>
</template>

<script>
import axios from "axios";

export default {
	name: "reports-form-detail-process",
	props: ["tittle"],
	data() {
		return {
			spinSettings: { position: "Right", width: 20 },
			disabledButton: false,
		};
	},
	methods: {
		validateBeforeSubmit: function () {
			this.enableButton(false);
			axios
				.post("/auth/reports/structuring/getDetailProcess")
				.then(({data}) => {
					Vue.prototype.$eventHub.$emit(
						"loadDataReports",
						this.$props.tittle,
						data
					);
				})
				.finally( () => {
					this.enableButton(true);
				});
			},
			
		enableButton(status){
			this.disabledButton = !status;
			//this don't appear that function.
			if(status && this.refs){
				this.$refs.progressBtn.stop();
				this.$refs.progressBtn.refresh();
			}
		}
	},
};
</script>
